import React, { useRef, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as VkIcon } from 'assets/svg/VK.svg';
import { ReactComponent as InstagramIcon } from 'assets/svg/instagram.svg';
import { ReactComponent as RutubeIcon } from 'assets/svg/rutube.svg';
import { ReactComponent as YoutubeIcon } from 'assets/svg/youtube.svg';


export default function Footer() {

  let location = useLocation();
  const [showContactInfo, setShowContactInfo] = useState(false)
  useEffect(() => {
    if (location.pathname === "/" || location.pathname.split("/")[1] === "artist" || location.pathname.split("/")[1] === "music" || location.pathname.split("/")[1] === "concerts") {
      setShowContactInfo(false)
    } else {
      setShowContactInfo(true)
    }
  }, [location.pathname])

  return (
    <div className="footer">
      <div className="footer__center">
        <div className="footer__menu">
          <Link to="/concerts">
            <div> Концерты </div>
          </Link>
          <Link to="/music">
            <div> Музыка </div>
          </Link>
        </div>
        {/* social links */}
        <div className="footer__links">
        {/* 
        <a className="footer__link footer__link-tiktok" rel="noopener noreferrer" href="https://vm.tiktok.com/ZSxbno9F/" target="_blank">
          <TiktokIcon />
        </a>
        <a className="footer__link footer__link-spotify" rel="noopener noreferrer" href="https://open.spotify.com/artist/10MgajZ7vRn9LVChqjykmj" target="_blank">
          <SpotifyIcon />
        </a>
        <a className="footer__link footer__link-apple" rel="noopener noreferrer" href="https://music.apple.com/ru/artist/%D1%80%D0%B8%D1%88%D0%B0%D1%82-%D1%82%D1%83%D1%85%D0%B2%D0%B0%D1%82%D1%83%D0%BB%D0%BB%D0%B8%D0%BD/1529902345" target="_blank">
          <AppleIcon />
        </a>
        */}
        <a className="footer__link footer__link-vk" rel="noopener noreferrer" href="https://vk.com/rishat_tukhvatullin_rt" target="_blank">
          <VkIcon />
        </a>
        <a className="footer__link footer__link-youtube" rel="noopener noreferrer" href="https://rutube.ru/channel/46152335/" target="_blank">
          <RutubeIcon />
        </a>
        {/* 
        */}
        <a className="footer__link footer__link-youtube" rel="noopener noreferrer" href="https://www.youtube.com/channel/UC09mFevxJZCYyTve3yFffmQ" target="_blank">
          <YoutubeIcon />
        </a>
        <a className="footer__link footer__link-instagram" rel="noopener noreferrer" href="https://www.instagram.com/rishat_thv/" target="_blank">
          <InstagramIcon />
        </a>
      </div>
        <div className="footer__contancts">
          Связаться +79276785599
        </div>
    {showContactInfo && <div className='footer__ip'>
          <p>ИП Анисимов Виталий Петрович<br/></p>
          <p>ОГРНИП 325169000013252<br/></p>
          <p>ИНН 165035515096<br/></p>
        </div>}
      </div>
      <div className="footer__credits">
        {/* Made by <a href="https://vk.com/reshreshus"> @reshreshus </a> */}
      </div>
    </div>
  )
}
